import React from 'react';
import { toast } from 'react-toastify';
import { MovementForm } from '../components/MovementForm';
import { useCreateMovement, useItems, useMovements } from '../hooks/useInventory';
import { DataTable } from '../components/DataTable';

const Movements: React.FC = () => {
  const { data: items } = useItems(); const { data: movements } = useMovements(); const createMovement = useCreateMovement();
  const handleSubmit = (values: any) => createMovement.mutate(values, { onSuccess: () => toast.success('Movimiento registrado'), onError: () => toast.error('No se pudo registrar') });
  return (
    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="border rounded-md p-4 bg-white"><h1 className="text-xl font-semibold mb-2">Movimientos</h1><MovementForm items={items?.data ?? []} onSubmit={handleSubmit} isSubmitting={createMovement.isPending} /></div>
      <div className="border rounded-md p-4 bg-white"><DataTable title="Historial" data={movements?.data ?? []} columns={[{ key: 'itemId', label: 'Ítem' }, { key: 'type', label: 'Tipo' }, { key: 'qty', label: 'Cantidad' }]} /></div>
    </div>
  );
};

export default Movements;
